module.exports = __webpack_public_path__ + "d9496a234c81179afbca6bf5959cc30a.svg";